export const getIdClassNameHelper = (text: string | number | undefined) => {
  if (!text) {
    return '';
  }
  const ret = text
    .toString()
    .replaceAll(/([^\w+])/g, '-')
    .toLowerCase();
  return `_id_${ret}`;
};
